import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import store from "../../redux/store/store";
import {apiLoading} from "../../redux/slice/apiSlice";
import {handleActiveError} from "../../components/sonner/ToastBasic";
import {apiRequest} from "../../components/Utils/SimmsUtils";

const selectServiceCodes = async () => {
    try {
        return await needAuth.get(`/serviceCodes`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const selectServiceCodeByParentId = async (parentId) => {
    return apiRequest(() => needAuth.get(`/serviceCodes/parents/${parentId}`));
}

const selectServiceCodeForDrawer= async (parentId) => {
    try {
        return await needAuth.get(`/serviceCodes/parents/drawer/${parentId}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const selectServiceCodeList = async () => {
    try {
        return await needAuth.get(`/serviceCodes/codes`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const selectAllParentsById = async (id) => {
    try {
        return await needAuth.get(`/serviceCodes/${id}/parents`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getServiceCode = async (codeId, success) => {
    return apiRequest(() => needAuth.get(`/serviceCodes/${codeId}`), success)
}

const saveServiceCode = async (data, success, duplicated) => {
    return apiRequest(
        () => needAuth.post(`/serviceCodes/create`, data),
        success,
        duplicated,
    );
}

const deleteServiceCode = async (codeId, success, failure) => {
    try {
        store.dispatch(apiLoading(true));
        const response = await needAuth.delete(`/serviceCodes/${codeId}`);
        if (response && response.status === 200) {
            if (success) success();
        } else if (response && response.status === 202) {
            const data = response.data;
            if (failure) failure();
            handleActiveError({message: data.title, description: data.reason});
        }
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
}

const updateServiceCodeName = async (data, success, duplicated) => {
    return apiRequest(() => needAuth.put(`/serviceCodes/name`, data), success, duplicated);
}

const updateServiceCode = async (data, success, failure) => {
    try {
        store.dispatch(apiLoading(true));
        const response = await needAuth.put(`/serviceCodes`, data);
        if (response) {
            if (response.status === 200) {
                if (success) success();
            } else if (response.status === 202) {
                if (failure) failure();
            }
        }
    } catch (error) {
        if (error instanceof AxiosError) {
            handleActiveError({message: "서버에러"});

            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
}

export {
    selectServiceCodes,
    selectServiceCodeByParentId,
    selectAllParentsById,
    selectServiceCodeList,
    getServiceCode,
    saveServiceCode,
    deleteServiceCode,
    updateServiceCode,
    updateServiceCodeName,
    selectServiceCodeForDrawer
};